/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
  'N/record',
  'N/runtime',
  'N/log',
  'N/search',
   'N/file',
], function (
  record,
  runtime,
  log,
  search,
  file
) {
    'use strict';

    var MyEventAgendaModule = {

        get: function (request) {

        //  log.debug("request", JSON.stringify(request));

          var getsku = request.parameters.getsku;
        //  alert(getsku)
        //  log.debug("getsku", JSON.stringify(getsku));

            var self = this;
            var type = 'customsearch679';
     //        var searchResults = search.load({
     //            id: type
     //          })//.run().getRange({start: 0, end: 1000});
     //  var value = 'SBI230001';
     // searchResults.filters.push(search.createFilter({
     //      name: 'custrecord_nus_ems_itemcode',
     //      join: 'CUSTRECORD_NUS_REFEVENTCODE',
     //      operator: search.Operator.ANYOF,
     //      values: value
     //  }))

var searchResults = search.create({
   type: "customrecord_nus_ems_agenda",
   filters:
   [
      ["custrecord_nus_refeventcode.custrecord_eventcode","is",getsku]
   ],
   columns:
   [
      search.createColumn({name: "name", label: "Name"}),
      search.createColumn({
         name: "custrecord_nus_agenda_stime",
         sort: search.Sort.ASC,
         label: "Start Time "
      }),
      search.createColumn({name: "custrecord_nus_agenda_endtime", label: "End Time "}),
      search.createColumn({name: "custrecord_nus_emsagdiscription", label: " Discription"}),
      search.createColumn({
         name: "custrecord_nus_ems_itemcode",
         join: "CUSTRECORD_NUS_REFEVENTCODE",
         label: "Ref Item Code "
      }),
      search.createColumn({name: "custrecord_nus_ems_instructor", label: "Instructor"})

   ]
});
   // log.debug('customrecord_nus_ems_agenda searchResults', JSON.stringify(searchResults));
      var searchResults = searchResults.run().getRange({start: 0, end: 1000});
        var mappedResultsEventAgenda = searchResults.map(function (result,index) {
          //var sku = self.getSKU();
        //  console.log('Item SKU:', sku);
            //  var fileInternalId =  result.getValue({name: "custrecord_nus_emsorglogo",join: "CUSTRECORD_NUS_EVENTSPONSER"});
            //  var imageUrl = self.getImageURL(fileInternalId);
                return {
                  id: index + 1 ,
                  itemcode: result.getText({name: "custrecord_nus_ems_itemcode",join: "CUSTRECORD_NUS_REFEVENTCODE"}),
                  name: result.getValue({name: "name"}),
                  starttime: result.getValue({name: "custrecord_nus_agenda_stime"}),
                  endtime: result.getValue({name: "custrecord_nus_agenda_endtime"}),
                  description: result.getValue({name: "custrecord_nus_emsagdiscription"}),
                  instructor: result.getText({name: "custrecord_nus_ems_instructor"})
                //  image: result.getValue({name: "custrecord_nus_emsorglogo",join: "CUSTRECORD_NUS_EVENTSPONSER"}),
                }
            });
        /*    var itemModel = this.model.getItem();
             if (itemModel) {
                 var sku = itemModel.get('sku');
                 console.log('Item SKU:', sku);
             }*/

            //log.debug('mappedResultsEventAgenda searchResults', JSON.stringify(mappedResultsEventAgenda));
          return mappedResultsEventAgenda;

        }
,
    getImageURL: function (fileInternalId) {
        var self = this;
        try {
          // Load the file by internal ID
          var fileObj = file.load({
            id: fileInternalId
          });

          // Get the URL of the image
          var imageURL = fileObj.url;

          return imageURL;
        } catch (e) {
          log.error('Error', e.message);
          return null;
        }
      }
  ,
  getSKU: function () {
            // Retrieve the SKU attribute from the item model
             var itemModel = this;
            return this.get('sku');
        },
    }

    return MyEventAgendaModule
})
